import { IMiniGameProps } from '../../../../../../typings/common';
import { BGRorB, BonusRedBlackGif } from '../../../../../assets';
import BonusGameCard from './BonusGameCard';

function BGBlackAndRedGame({
	isSmall,
	onStartGame,
	onRequireLogin,
	canPlay,
	config,
	miniGameData,
	playerLevel,
}: IMiniGameProps) {
	return (
		<BonusGameCard
			isSmall={isSmall}
			onStartGame={onStartGame}
			onRequireLogin={onRequireLogin}
			canPlay={canPlay}
			config={config}
			miniGameData={miniGameData}
			playerLevel={playerLevel}
			titleSource={BGRorB}
			thumbSource={BonusRedBlackGif}
			launchPath='/blackAndRed/bowaPlayer.html'
			cooldownHours={4}
			freePlayTitleFontSize={12}
			infoPaddingVertical={2}
		/>
	);
}

export default BGBlackAndRedGame;
